import React from "react";
import { Formik, FormikProps } from "formik";
import { IManagementStore } from "@src/Stores/Management/types";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Grid, Button, Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { STMainWrapper, CSTPaper } from "./styles";
import { WebSocketSession } from "@src/Interfaces/Entity/WebSocketSession";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import moment from "moment";
import _ from "lodash";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  management?: IManagementStore;
}

interface IFormValues {}

@inject("management")
@observer
export default class WebSocketSessions extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  sessions: WebSocketSession[] = [];

  async componentDidMount() {
    document.title = Values.getLocalizationValue("webSocketSessions");

    await this.getSessions();
    this.isLoading = false;
  }

  getSessions = async () => {
    this.sessions = await this.props.management.getWebSocketSessions();
  };

  handleSubmit = async () => {
    await this.getSessions();
  };

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }

    return (
      <Grid container justify="center">
        <STMainWrapper>
          <Formik
            initialValues={{}}
            onSubmit={this.handleSubmit}
            render={(formikProps: FormikProps<IFormValues>) => (
              <form onSubmit={formikProps.handleSubmit}>
                <Grid container>
                  <Grid xs item>
                    <STPageHeader>{Values.getLocalizationValue("webSocketSessions")}</STPageHeader>
                  </Grid>
                  <Grid xs item>
                    <Grid container justify="flex-end">
                      <Button type="submit" variant="contained" color="primary">
                        {Values.getLocalizationValue("refresh")}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <div>
                  <Grid container justify="center">
                    {this.sessions.length > 0 ? (
                      <CSTPaper elevation={2}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <STTableHeadTypography>{Values.getLocalizationValue("person")}</STTableHeadTypography>
                              </TableCell>
                              <TableCell>
                                <STTableHeadTypography>
                                  {Values.getLocalizationValue("application")}
                                </STTableHeadTypography>
                              </TableCell>
                              <TableCell>
                                <STTableHeadTypography>{Values.getLocalizationValue("duration")}</STTableHeadTypography>
                              </TableCell>
                              <TableCell>
                                <STTableHeadTypography>
                                  {Values.getLocalizationValue("connections")}
                                </STTableHeadTypography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.sessions.map(session => {
                              let from = moment
                                .utc(session.startedTimeString)
                                .local()
                                .toNow(true);
                              return (
                                <TableRow hover>
                                  <TableCell>
                                    <STTableCellTypography>{session.personName}</STTableCellTypography>
                                  </TableCell>
                                  <TableCell>
                                    <STTableCellTypography>{session.applicationName}</STTableCellTypography>
                                  </TableCell>
                                  <TableCell>
                                    <STTableCellTypography>{from}</STTableCellTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <STTableCellTypography>{session.count}</STTableCellTypography>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </CSTPaper>
                    ) : (
                      <ResultsAreEmpty />
                    )}
                  </Grid>
                </div>
              </form>
            )}
          />
        </STMainWrapper>
      </Grid>
    );
  }
}
